var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"target-price-forecast"},[_c('MoreTitle',{attrs:{"title":"目标价预测"}}),_c('div',{staticClass:"chart-box edge-padding"},[_c('VueEcharts',{attrs:{"option":_vm.option}}),(_vm.goalpriceData.lowPrice)?_c('div',{staticClass:"line-box"},_vm._l(([..._vm.legendMap].reverse()),function(item){return _c('div',{key:item.alias,staticClass:"line",style:({
          transform: `scaleX(${item.pre / _vm.goalpriceData.lowPrice})`,
          backgroundColor: `${item.color}`
        })})}),0):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }